import { render, staticRenderFns } from "./right_3.vue?vue&type=template&id=7c6b475d&scoped=true&"
import script from "./right_3.vue?vue&type=script&lang=js&"
export * from "./right_3.vue?vue&type=script&lang=js&"
import style0 from "./right_3.vue?vue&type=style&index=0&id=7c6b475d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6b475d",
  null
  
)

export default component.exports